import styled from 'styled-components';

export const Wrapper = styled.nav`
  z-index: 60;
  cursor: pointer;

  .-desktop & {
    max-height: 100%;
    display: flex;
    position: relative;
    pointer-events: all;
  }

  .-mobile & {
    width: 100%;
    max-height: 100%;

    &.open {
      height: auto;
      display: flex;
      align-items: flex-end;
      display: block;
      background: none;
    }
  }
`;

export const OtherResultsIndicatorMobile = styled.div`
  position: absolute;
  height: 10px;
  width: 10px;
  inset-inline-end: 9px;
  top: 9px;
  background-color: var(--color-mapNavSearchResults);
  border-radius: 50%;
  display: inline-block;
`;

export const Submenu = styled.div`
  background: var(--color-background);

  button:first-child {
    box-shadow: inset 0 4px 4px -2px rgba(46, 48, 50, 0.4);
  }
  button:last-child {
    box-shadow: inset 0 -4px 4px -2px rgba(46, 48, 50, 0.4);
    border-bottom: none;
  }
`;

export const ToggleShowMenuButtonMobile = styled.button`
  cursor: pointer;
  pointer-events: all;
  position: relative;
  /* Ensure button stays above interactive map layers at narrow widths */
  z-index: 200;
  margin: 0;
  padding: 0;
  border-radius: 100%;
  outline: none;
  border: none;
  background: var(--color-background);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  &:focus-visible {
    outline: var(--focus-outline);
    outline-offset: 2px;
  }

  & svg {
    fill: var(--color-secondaryText);
  }
`;

export const MapNavigatorMobileWrapper = styled.div`
  pointer-events: all;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* Keep the navigator from ever going above 64px from the top of the viewport */
  position: sticky;
  top: 64px;
  /* Constrain height so internal content scrolls instead of pushing past the sticky offset */
  max-height: calc(100vh - 64px);
  background: var(--color-background);
`;

export const MapNavigatorMobile = styled.div`
  pointer-events: all;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: var(--color-background);
`;

export const BuildingWrapperMobile = styled.div`
  width: inherit;
  background: var(--color-background);
`;
export const BuildingDropdownMobile = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  border-bottom: 1px solid var(--color-mapNavBackground);
  padding: 16px 8px;
  background: var(--color-mapNavBackground);
  width: inherit;

  .buildingName {
    color: var(--color-mapNavText);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .indicator {
    border-radius: 100%;
    height: 26px;
    width: 26px;
    background: var(--color-mapNavSearchResults);
    color: var(--color-mapNavSearchResultsText);
    position: absolute;
    inset-inline-end: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }

  &:focus-visible {
    outline: var(--focus-outline);
    outline-offset: -3px;
  }
`;
export const LevelDropdownMobile = styled.button`
  width: 100%;
  outline: none;
  border: none;
  border-bottom: 1px solid #ebebeb;
  padding: 13px 48px;
  text-align: inherit;
  position: relative;
  background: var(--color-background);

  &.selectedBg {
    background: var(--color-primary-05);
  }

  .selected {
    height: 100%;
    width: 4px;
    inset-inline-start: 0;
    top: 0;
    background-color: var(--color-primary);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    position: absolute;
  }

  .levelName {
    color: var(--color-primaryText);
    font-weight: 500;
    ${({ theme }) => theme.fontSize('16px')};
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .secondaryLabel {
    color: var(--color-secondaryText);
    ${({ theme }) => theme.fontSize('14px')};
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .indicator {
    border-radius: 100%;
    height: 26px;
    width: 26px;
    background: var(--color-mapNavSearchResults);
    color: var(--color-mapNavSearchResultsText);
    position: absolute;
    top: 19px;
    inset-inline-end: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }

  &:focus-visible {
    outline: var(--focus-outline);
    outline-offset: -3px;
  }
`;
export const DragCloseButton = styled.button`
  position: relative;
  flex: none;
  min-height: 44px;
  background: var(--color-background);
  outline: none;
  display: flex;
  justify-content: center;
  border: 1px solid var(--color-secondaryButton) !important;
  border-radius: ${({ theme }) => {
    const radius = theme.standardRadius;
    return `${radius} ${radius} 0 0;`;
  }};
  cursor: pointer;

  &::after {
    position: absolute;
    inset-block-start: 10px;
    inset-inline-start: calc(50% - 22px);
    width: 44px;
    height: 5px;
    border-radius: 9999px;
    background-color: var(--color-secondary);
    content: '';
    opacity: 0.7;
  }

  &:focus-visible {
    outline: var(--focus-outline);
    outline-offset: -2px;
  }
`;

export const DragIndicator = styled.div`
  width: auto;
  height: 15px;
  outline: none;
  border: none;
  background: var(--color-background);
  border: 1px solid green;
`;

export const ShowOtherResultsBanner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: auto auto 0;
  padding-inline-start: 8px;
  padding-inline-end: 16px;
  transition: 0.5s ease-in-out opacity;
  background: var(--color-background);
  border: 1px solid var(--color-secondaryButton);
  border-radius: 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const BannerLabel = styled.div`
  color: var(--color-secondaryText);
  line-height: 18px;
  ${({ theme }) => theme.fontSize('14px')};
  margin-inline-start: 4px;
`;

export const ShowOtherResultsBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 54px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 60;
`;

export const BannerIconWrapper = styled.div`
  position: relative;
`;

export const OtherResultsIndicatorBanner = styled(OtherResultsIndicatorMobile)`
  inset-inline-end: 5px;
  top: 5px;
`;
